import { PuzzleThemeCharacter, PuzzleThemeMedia } from "./types";

export class PuzzleAPI {
  static async getPuzzleTheme(): Promise<{
    list: PuzzleThemeCharacter[] | null,
    error?: string
  }> {
    try {
      const apiData = await fetch(
        `https://puzzle.snackbook.cc/api/v1/puzzle/themes?page=1&page_size=100&all_themes=true`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(res => res.json());
      if(apiData && apiData.data && apiData.data.list){
        let api_arr: PuzzleThemeCharacter[] = apiData.data.list;
        let list = api_arr.filter(item => item.name !== "nature" );
  
        let index = list.findIndex(item => item.name === "free");
        if(index !== -1){
          let free_info = list.splice(index, 1);
          list.unshift(free_info[0]);
        };
        let member_index = list.findIndex(item => item.name === "member_only");
        if(member_index !== -1){
          let member_info = list.splice(member_index, 1);
          member_info[0].price = "sub-only";
          member_info[0].price_num = 8000;
          list.splice(1, 0, member_info[0]);
        };

        return { list };
      }else{
        throw new Error('Invalid API response');
      };
    } catch (err) {
      console.error('Failed to validate purchase:', err);
      return { list: null, error: 'Failed to validate purchase' };
    }
  };
  static async getPuzzleImages(
    id: string
  ): Promise<{
    list: PuzzleThemeMedia[] | null, error?: string
  }> {
    try {
      const apiData = await fetch(
        `https://puzzle.snackbook.cc/api/v1/puzzle/theme/images?page=1&page_size=1000&theme_id=${id}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(res => res.json());
      
      if(apiData && apiData.data && apiData.data.list){

        return { list: apiData.data.list };
      }else{
        throw new Error('Invalid API response');
      };
    } catch (err) {
      console.error('Failed to validate purchase:', err);
      return { list: null, error: 'Failed to validate purchase' };
    }
  }
}